import Vue from 'vue';
Vue.filter("name",function(){
  
})

Vue.filter("formatTime", function (num) {
  if (num == 0) {
    return "00:00"
  }
  if (!num) return
  let hh = parseInt(num / 3600)
  let mm = parseInt((num % 3600) / 60)
  let ss = ((num % 3600) % 60)
  if (hh <= 0) {
    return (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss);
  }
  return (hh < 10 ? '0' + hh : hh) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss);
})

Vue.prototype.formatDateA = function (date, type) {
  if (!date) return
  try{
    date = new Date(date.replace(/-/g, "/"));
  }catch(err){}
  date = new Date(date)
  let month = date.getMonth() + 1
  let day = date.getDate()
  let year = date.getFullYear()
  if (type == 'month') {
    return month
  }
  if (type == 'day') {
    return day
  }
  if (type == 'year') {
    return year
  }
  let nd = day < 10 ? '0' + day : day
  let nm = month < 10 ? '0' + month : month
  if (type == 'day/month') {
    return nd + "/" + nm
  }
  if (type == 'month-day') {
    return nm + "-" + nd
  }
  if (type == "yymmdd") {
    return year + "-" + nm + "-" + nd
  }
}